import { render, staticRenderFns } from "./TeaserBox.vue?vue&type=template&id=efb2440e&"
import script from "./TeaserBox.vue?vue&type=script&lang=js&"
export * from "./TeaserBox.vue?vue&type=script&lang=js&"
import style0 from "./TeaserBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports